// extracted by mini-css-extract-plugin
export default {"iconContainer":"CustomDialog_iconContainer__c1FTi"};